import axios from "./axios-handler.service";
const BASE_URL = "/api/Fornecedor";

export interface Fornecedor {
  idFornecedor: string;
  nome: string;
  cor: string;
  logo: string;
  logoCompleta: string;
  teste: string;
  sigla: string;
  tipo: string;
  ehHolding: boolean;
  // Opcional de proposito: a API serializa com NullValueHandling.Ignore, entao quando o
  // fornecedor nao pertence a uma holding a chave nem vem no JSON.
  idFornecedorHolding?: string | null;
  dataCriacao: Date;
  dataAlteracao: Date;
  excluido: boolean;
}

export class FornecedoresService {
  static async listarFornecedoresGlobais(
    txtPesquisa: string | null,
    somenteAtivos: boolean
  ): Promise<Fornecedor[]> {
    const response = await axios.get<Fornecedor[]>(
      `${BASE_URL}/ListarFornecedoresGlobais`,
      {
        params: {
          txtPesquisa: txtPesquisa || "",
          ativo: somenteAtivos,
        },
      }
    );
    return response.data;
  }

  static async listarHoldings(): Promise<Fornecedor[]> {
    const response = await axios.get<Fornecedor[]>(`${BASE_URL}/ListarHoldings`);
    return response.data;
  }

  static async definirHolding(
    idFornecedor: string,
    idFornecedorHolding: string | null
  ): Promise<void> {
    await axios.post(`${BASE_URL}/DefinirHolding`, {
      idFornecedor,
      idFornecedorHolding,
    });
  }

  static async listarFornecedoresGlobaisSemCatalogo(): Promise<Fornecedor[]> {
    const response = await axios.get<Fornecedor[]>(
      `${BASE_URL}/ListarFornecedoresGlobaisSemCatalogo`
    );
    return response.data;
  }
  static async obter(id: string): Promise<Fornecedor> {
    const response = await axios.get<Fornecedor>(`${BASE_URL}/Obter`, {
      params: { id },
    });
    return response.data;
  }
  static async manterFornecedor(
    fornecedor: Fornecedor,
    logoBase64: string
  ): Promise<void> {
    const response = await axios.post(`${BASE_URL}/ManterFornecedor`, {
      fornecedor,
      logoBase64,
    });
    return response.data;
  }
}
